import { useTooltips } from '@/stores/insights/tooltips';
import { storeToRefs } from 'pinia';

export const getTooltip = (tooltipKey) => {
  const { tooltips } = storeToRefs(useTooltips());

  const { body_r: html } = tooltips.value?.[tooltipKey] || {};

  return { key: tooltipKey, html: html || '', title: '' };
};

export const reqOnHoldTooltipText = 'This requisition is currently on hold. If it\'s no longer active, consider closing it in your ATS.';
